import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Error from '../../shared/Error';
import Loading from '../../shared/Loading';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSession from '../../../hooks/useSession';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { asyncActions } from '../../../actions/general';
import { formatCurrency } from '../../../lib/utils/formatters';
import { getCreditLineAvailable } from '../../../actions/companies';
import { loading } from '../../../actions/sessions';
import { supportPhone } from '../../../lib/constants/SiteVariables';

export default function PastDue({ location }) {
  const [session, sessionActions] = useSession();
  const dispatch = useDispatch();

  const company = useSessionEntity('company');
  const user = useSessionEntity('user');

  const [tclAvailable, setTclAvailable] = useState(0);

  useRouteStatus(location);

  useEffect(() => {
    if (company) {
      dispatch(loading(true));
      dispatch(asyncActions(getCreditLineAvailable(company.id)))
        .then((res) => setTclAvailable(res.attributes.data))
        .then((res) => dispatch(loading(false)));
    }
  }, [company, dispatch]);

  useEffect(() => {
    sessionActions.finish();
  }, []);

  let bodyText = '';
  if (company.credit_line.get('amount') > 0) {
    bodyText = (
      <>
        <p className="mb-5">
          Good news! You have {formatCurrency(tclAvailable)} to spend with
          Credit Key!
        </p>

        <p className="mb-5">
          Unfortunately your account is past due. In order to continue using
          your line of credit, please contact us at{' '}
          <a href="mailto: support@creditkey.com">support@creditkey.com</a> |{' '}
          {supportPhone} immediately to resolve this issue.
        </p>
      </>
    );
  } else {
    bodyText = (
      <>
        <p className="mb-5">
          There seems to be a problem with your Credit Key account.
        </p>

        <p className="mb-5">
          Please contact us ASAP:
          <br />
          <a href="mailto: support@creditkey.com">
            support@creditkey.com
          </a> | {supportPhone}
        </p>
      </>
    );
  }

  if (!user || !company) return <Loading className="w-14 h-14" />;

  return (
    <div id="content" className="text-center">
      <div className="text-xl font-avenir-black text-navy-blue">
        Hi {user.first_name}
      </div>

      <Error />

      {bodyText}
    </div>
  );
}
